import dashboardTypes from './dashboardTypes'

export const initialState = {
  quickNumbers: {},
  loadingQuickNumbers: false,
  quickNumbersAlreadyLoaded: false,
  quickNumbersError: '',
  events: [],
  loadingEvents: false,
  eventsAlreadyLoaded: false,
  eventsError: ''
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case dashboardTypes.FETCH_EVENTS: {
      return {
        ...state,
        events: [],
        loadingEvents: true,
        eventsError: ''
      }
    }
    case dashboardTypes.FETCH_EVENTS_SUCCESS: {
      return {
        ...state,
        loadingEvents: false,
        eventsError: '',
        events: payload,
        eventsAlreadyLoaded: true
      }
    }
    case dashboardTypes.FETCH_EVENTS_FAILURE: {
      return {
        ...state,
        loadingEvents: false,
        eventsError: payload
      }
    }
    case dashboardTypes.FETCH_QUICK_NUMBERS: {
      return {
        ...state,
        quickNumbers: {},
        loadingQuickNumbers: true,
        quickNumbersError: ''
      }
    }
    case dashboardTypes.FETCH_QUICK_NUMBERS_SUCCESS: {
      return {
        ...state,
        loadingQuickNumbers: false,
        quickNumbersError: '',
        quickNumbers: payload,
        quickNumbersAlreadyLoaded: true
      }
    }
    case dashboardTypes.FETCH_QUICK_NUMBERS_FAILURE: {
      return {
        ...state,
        loadingQuickNumbers: false,
        quickNumbersError: payload
      }
    }

    default:
      return state
  }
}
